import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Components } from '@one/web-components';
import { LabelService } from '../../services/label.service';

interface DialogData {
  HEADER: string,
  DESC: string[],
  CONFIRM_BTN?: string,
  CANCEL_BTN?: string,
  FOOTER_TEXT?: string,
  VALIDATION_TEXT?: string,
  qcStatus?:boolean,
  reason?:boolean,
  CANCEL_REASON?:string,
  CANCEL_SUBMIT?:string,
  REASON_DESC?:string,
  hasFailed?:boolean
}

@Component({
  selector: 'app-confirmation-popup-without-spinner',
  templateUrl: './confirmation-popup-without-spinner.component.html',
  styleUrls: ['./confirmation-popup-without-spinner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ConfirmationPopupWithoutSpinnerComponent {
  @ViewChild('typographyElement', { static: true }) typographyElement!: Components.OwcTypography;
  @ViewChild('progressSpinnerElement', { static: true }) progressSpinnerElement!: Components.OwcProgressSpinner;
  formView:boolean=false;
  i18n = this.labelService.labels;
  studyPattern = "^[a-zA-Z0-9]*$";
  reasonForm = new FormGroup({    
      reason: new FormControl(''),
    })
  
  visible: boolean = true;
  constructor(@Inject(DIALOG_DATA) protected data: DialogData, 
  public dialogRef: DialogRef<boolean|string>,private readonly labelService: LabelService) {     
   }
  onAccept() {
    if(!this.data.hasFailed) {
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close('NAVIGATE');
    }
  }
  onDecline() {
    if(this.data.reason){
        this.formView = true;
    }else{
      this.dialogRef.close(false);
    }
  }
  onReasonDecline(){
    this.formView = false;
  }
  onAcceptReason(){
    
    this.reasonForm.get('reason')?.setValidators(
      [Validators.required]);
    this.reasonForm.get('reason')?.markAllAsTouched();
    this.reasonForm.get('reason')?.updateValueAndValidity();
    if (this.reasonForm.valid) {
      this.formView=false;
      let reasonValue:any = this.reasonForm.get('reason')?.value;
      this.dialogRef.close(reasonValue);
    }
    
  }
}
